import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import {
  useContext,
  lazy,
  Suspense,
  useCallback,
  useEffect,
  useState,
} from "react";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import "./style/app.css";
import "./style/adminhome.css";
import "./style/inPlay.css";
import "./style/odds.css";
import Spinner from "./components/Spinner";
import axios from "axios";
import API_BASE_URL from "./constant/Api_base_url";
// import ENDPOINT from "./constant/Endpoint";
import { ReqCallContext, ReqCallProvider } from "./context/ReqCallContext";
import { io } from "socket.io-client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Installs the global CSRF axios interceptors (x-xsrf-token attach + harvest)
// and the in-memory token store.
import "./utils/api";
// Cookie-only auth: every API call must carry the session cookie.
axios.defaults.withCredentials = true;
const Main = lazy(() => import("./components/Main"));
const Login = lazy(() => import("./components/Login"));
const Landing = lazy(() => import("./components/Landing"));

const ENDPOINT = process.env.NODE_ENV === "development" ? "http://localhost:9001" : "https://fly247-api-849433205741.asia-south1.run.app";
const underMaintanence = false;

function App() {
  const [userContext, setUserContext] = useContext(AuthContext);
  const [reqCall, setReqCall] = useContext(ReqCallContext);
  const navigate = useNavigate();

  // Socket connection for online status
  const [socket, setSocket] = useState(null);

  // Aviator state management
  const [showAviator, setShowAviator] = useState(false);
  const [unityLoaded, setUnityLoaded] = useState(false);

  function openNav() {
    document.getElementById("mySidebar").style.transition = "0.3s ease";
    document.getElementById("mySidebar").style.left = "0";
  }

  function closeNav() {
    document.getElementById("mySidebar").style.transition = "none";
    document.getElementById("mySidebar").style.left = "-100%";
  }

  // Socket connection and online status management
  useEffect(() => {
    if (userContext.token && userContext.details) {
      // Create socket connection
      const newSocket = io(ENDPOINT, {
        path: "/socket/odds/",
        transports: ["polling"],
      });

      newSocket.on("connect", () => {
        console.log("Connected to online status server");

        // Authenticate user with socket server
        newSocket.emit("authenticate", {
          username: userContext.details.username,
          level: userContext.details.level || 1,
        });
      });

      newSocket.on("disconnect", () => {
        console.log("Disconnected from online status server");
      });

      setSocket(newSocket);

      return () => {
        newSocket.disconnect();
      };
    }
  }, [userContext.token, userContext.details]);

  const verifyUser = async () => {
    try {
      if (userContext.token) {
        const response = await axios.post(
          API_BASE_URL + "/auth/checkUserActive",
          {},
          {
            headers: {
              "Content-Type": "application/json",
            },
            withCredentials: true,
          }
        );
        if (response.status === 200) {
          const data = response.data;
          setUserContext((oldValues) => {
            // Cookie-only auth: no token in body; keep the login marker and
            // refresh details. Never write data.token (undefined wipes login).
            // MERGE (not replace): checkUserActive returns a minimal user
            // object without total_coins/exposure, so a replace would wipe the
            // balance the header shows (0 on refresh).
            return {
              ...oldValues,
              token: oldValues.token || "cookie",
              details: {
                ...(oldValues.details || {}),
                ...(data.user || data.details || {}),
              },
            };
          });
        }
      }
    } catch (error) {
      if (error.response.status === 401) {
        setUserContext((oldValues) => {
          return { ...oldValues, details: null, token: null };
        });
      }
    }
  };
  useEffect(() => {
    verifyUser();
  }, [reqCall]);
  const syncLogout = useCallback((event) => {
    if (event.key === "userLogout") {
      // If using react-router-dom, you may call history.push("/")
      window.location.reload();
      navigate("/");
    }
  }, []);
  useEffect(() => {
    window.addEventListener("storage", syncLogout);
    return () => {
      window.removeEventListener("storage", syncLogout);
    };
  }, [syncLogout]);
  if (underMaintanence) {
    return (
      <div
        className="myloading"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "#0E0E0E!important",
        }}
      >
        <div>
          <img
            src={require("./images/logo.png")}
            style={{
              height: 70,
              width: "100%",
              objectFit: "contain",
              margin: "auto",
            }}
          />
          <div style={{ fontSize: "2em", textAlign: "center" }}>
            Under maintainence
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="app">
      <ToastContainer position="top-right" autoClose={3000} />
      <Suspense fallback={<Spinner color="#222" style={{ marginTop: 20 }} />}>
        {userContext.token ? (
          <>
            <Main
              userContext={userContext}
              setUserContext={setUserContext}
              openNav={openNav}
              closeNav={closeNav}
              socket={socket}
              setShowAviator={setShowAviator}
              setUnityLoaded={setUnityLoaded}
            />
          </>
        ) : (
          <div>
            <div className="content non-user">
              <Routes>
                <Route
                  exact
                  path="/"
                  index
                  element={
                    <Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Landing />
                    </Suspense>
                  }
                />
                <Route
                  path="/login"
                  element={
                    <Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Login />
                    </Suspense>
                  }
                />

                <Route path="*" element={<Landing />} />
              </Routes>
            </div>
          </div>
        )}
        
      </Suspense>
    </div>
  );
}

const AppWrapper = () => (
  <LanguageProvider>
    <AuthProvider>
      <ReqCallProvider>
        <Router>
          <App />
        </Router>
      </ReqCallProvider>
    </AuthProvider>
  </LanguageProvider>
);
export default AppWrapper;
